// extracted by mini-css-extract-plugin
module.exports = {"identifyingCodeInput":"style_identifyingCodeInput__bn2HX","input":"style_input__8uYs8","btn":"style_btn__St2gR"};